module.exports = __webpack_public_path__ + "static/media/wifi-1.256475ff.svg";